/* eslint-disable */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import AdminPhotoUploader from "../components/AdminPhotoUploader";

const AMENITIES = ["wifi", "standingDesk", "phoneBooth", "parking"];
const STATES = ["Washington DC", "Maryland", "Virginia", "Pennsylvania", "New Hampshire", "Massachusetts"];
const TYPES = ["Coworking", "Event Space", "Cafe"];

export default function ListYourSpace() {
  const [form, setForm] = useState({
    name: "", contact_name: "", contact_email: "", phone: "",
    city: "Washington DC", neighborhood: "", address: "", type: "Coworking",
    description: "", hourly: "", daily: "", weekly: "", monthly: "",
    pricing_tbd: false,
    amenities: [], work_intent_tags: [], photo_urls: ["", "", ""], website: "",
  });
  // Session 50.1 · Photos as newline-joined URL string (AdminPhotoUploader
  // format). Applicants can drag/drop files instead of pasting URLs.
  const [photoValue, setPhotoValue] = useState("");
  const [submitted, setSubmitted] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [workIntents, setWorkIntents] = useState([]);

  useEffect(() => {
    api.get("/options/work-intents").then(r => setWorkIntents(r.data)).catch(() => {});
  }, []);

  const update = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));
  const toggleAm = (a) => setForm(f => ({ ...f, amenities: (f.amenities || []).includes(a) ? (f.amenities || []).filter(x => x !== a) : [...(f.amenities || []), a] }));
  const toggleIntent = (k) => setForm(f => ({ ...f, work_intent_tags: f.work_intent_tags.includes(k) ? f.work_intent_tags.filter(x => x !== k) : [...f.work_intent_tags, k] }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const uploadedPhotos = photoValue.split("\n").map(s => s.trim()).filter(Boolean);
      if (uploadedPhotos.length === 0) {
        setErr("Please add at least one photo of your space.");
        setBusy(false);
        return;
      }
      const payload = {
        ...form,
        hourly: (form.pricing_tbd || !form.hourly) ? null : Number(form.hourly),
        daily:  (form.pricing_tbd || !form.daily)  ? null : Number(form.daily),
        weekly: (form.pricing_tbd || !form.weekly) ? null : Number(form.weekly),
        monthly:(form.pricing_tbd || !form.monthly)? null : Number(form.monthly),
        photo_urls: uploadedPhotos,
      };
      const r = await api.post("/workspace-applications", payload);
      setSubmitted(r.data);
    } catch (e) {
      setErr(e?.response?.data?.detail || "Could not submit application.");
    } finally { setBusy(false); }
  };

  return (
    <div className="rec-page">
      <header className="rec-topbar">
        <Link to="/spaces" className="rec-brand"><span className="rec-brand-mark"><img src="/brand/metier-icon.png" alt="Métier" /></span></Link>
        <nav className="rec-topnav">
          <Link to="/spaces">Spaces</Link>
          <Link to="/login">Member sign in</Link>
        </nav>
      </header>
      <main className="rec-main" style={{maxWidth:900}}>
        {submitted ? (
          <div className="rec-confirm-card" data-testid="application-success">
            <span className="m-eyebrow">Received</span>
            <h1 className="rec-h1">Thank <em>you</em>.</h1>
            <p className="rec-desc">Your application is in. We&apos;ll review it within 48 hours and email you at <strong>{form.contact_email}</strong> to set up Stripe payouts and publish your listing.</p>
            <div className="rec-confirm-grid">
              <div><span className="m-eyebrow small">Application</span><span className="rec-conf-num">#{submitted.application_id.replace('app_','').toUpperCase()}</span></div>
              <div><span className="m-eyebrow small">Status</span><span>Pending review</span></div>
            </div>
            <Link to="/spaces" className="m-btn-gold" style={{textDecoration:"none"}}>Back to all spaces</Link>
          </div>
        ) : (
          <>
            <span className="rec-eyebrow">Métier · For hosts</span>
            <h1 className="rec-h1">List your <em>space</em>.</h1>
            <p className="m-lede" style={{maxWidth:680}}>Join a curated network of boutique workspaces. You set your own rates. Métier handles bookings and payments, the reservation lands in your account, automatically.</p>

            <form onSubmit={onSubmit} className="m-form" data-testid="apply-form" style={{marginTop:36,maxWidth:680}}>
              <h3 className="rec-h3" style={{marginTop:0}}>About the space</h3>
              <div className="m-form-grid-2">
                <label className="m-field"><span>Workspace name</span><input value={form.name} onChange={update("name")} required data-testid="apply-name"/></label>
                <label className="m-field"><span>Type</span>
                  <select value={form.type} onChange={update("type")} data-testid="apply-type">{TYPES.map(t => <option key={t}>{t}</option>)}</select>
                </label>
              </div>
              <div className="m-form-grid-2">
                <label className="m-field"><span>State</span>
                  <select value={form.city} onChange={update("city")} data-testid="apply-city">{STATES.map(s => <option key={s}>{s}</option>)}</select>
                </label>
                <label className="m-field"><span>Neighborhood / city</span><input value={form.neighborhood} onChange={update("neighborhood")} required data-testid="apply-neighborhood"/></label>
              </div>
              <label className="m-field"><span>Street address</span>
                <input value={form.address} onChange={update("address")} required placeholder="e.g. 60 Commercial St, Concord, NH 03301" data-testid="apply-address"/>
              </label>
              <label className="m-field"><span>Description (2–3 sentences)</span><textarea value={form.description} onChange={update("description")} required minLength={20} rows={4} style={{padding:"12px 14px",border:"1px solid var(--m-border)",borderRadius:9,background:"var(--cream)",fontSize:14,resize:"vertical"}} data-testid="apply-description"/></label>
              <label className="m-field"><span>Website (optional)</span><input value={form.website} onChange={update("website")} placeholder="https://" data-testid="apply-website"/></label>

              <h3 className="rec-h3">Rates</h3>
              <label className="m-field m-pricing-tbd" data-testid="apply-pricing-tbd-label">
                <input
                  type="checkbox"
                  checked={form.pricing_tbd}
                  onChange={(e) => setForm(f => ({ ...f, pricing_tbd: e.target.checked }))}
                  data-testid="apply-pricing-tbd"
                />
                <span>I&apos;m still working out pricing, post my space without rates and we&apos;ll follow up.</span>
              </label>
              <div className="m-form-grid-2">
                <label className="m-field"><span>Hourly $ {form.pricing_tbd ? "(skip)" : "(required)"}</span><input type="number" value={form.hourly} onChange={update("hourly")} required={!form.pricing_tbd} disabled={form.pricing_tbd} data-testid="apply-hourly"/></label>
                <label className="m-field"><span>Daily $ {form.pricing_tbd ? "(skip)" : "(required)"}</span><input type="number" value={form.daily} onChange={update("daily")} required={!form.pricing_tbd} disabled={form.pricing_tbd} data-testid="apply-daily"/></label>
              </div>
              <div className="m-form-grid-2">
                <label className="m-field"><span>Weekly $ (optional)</span><input type="number" value={form.weekly} onChange={update("weekly")} disabled={form.pricing_tbd} data-testid="apply-weekly"/></label>
                <label className="m-field"><span>Monthly $ (optional)</span><input type="number" value={form.monthly} onChange={update("monthly")} disabled={form.pricing_tbd} data-testid="apply-monthly"/></label>
              </div>

              <h3 className="rec-h3">Photos</h3>
              <p className="m-muted small" style={{marginTop:-4,marginBottom:10}}>
                Upload photos from your device (JPEG / PNG / WebP, up to 6MB each) or paste hosted image URLs. Drag to reorder — the first photo becomes your listing hero.
              </p>
              <AdminPhotoUploader
                value={photoValue}
                onChange={setPhotoValue}
                endpoint="/applications/uploads/photo"
                testid="apply-photos"
                previewName={form.name || "Your workspace"}
                previewMeta={`${form.neighborhood ? form.neighborhood + " · " : ""}${form.city}`}
                previewType={form.type}
              />

              <h3 className="rec-h3">Amenities</h3>
              <div className="m-amenities">
                {AMENITIES.map(a => (
                  <button type="button" key={a} className={"m-pill light" + ((form.amenities || []).includes(a) ? " active" : "")} onClick={() => toggleAm(a)} data-testid={`apply-am-${a}`}>{a}</button>
                ))}
              </div>

              <h3 className="rec-h3">Best For</h3>
              <p className="m-muted small" style={{marginTop:-6}}>Pick the kinds of work your space is genuinely best suited for. Members can filter by these tags.</p>
              <div className="m-amenities">
                {workIntents.map(w => (
                  <button type="button" key={w.key}
                    className={"m-pill light" + (form.work_intent_tags.includes(w.key) ? " active" : "")}
                    onClick={() => toggleIntent(w.key)}
                    data-testid={`apply-intent-${w.key}`}>{w.label}</button>
                ))}
              </div>

              <h3 className="rec-h3">Contact</h3>
              <div className="m-form-grid-2">
                <label className="m-field"><span>Your name</span><input value={form.contact_name} onChange={update("contact_name")} required data-testid="apply-contact-name"/></label>
                <label className="m-field"><span>Phone (optional)</span><input value={form.phone} onChange={update("phone")} data-testid="apply-phone"/></label>
              </div>
              <label className="m-field"><span>Email</span><input type="email" value={form.contact_email} onChange={update("contact_email")} required data-testid="apply-email"/></label>

              {err && <div className="m-form-err">{err}</div>}
              <button type="submit" className="m-btn-gold" disabled={busy} data-testid="apply-submit" style={{marginTop:14}}>
                {busy ? "Submitting…" : "Submit application"}
              </button>
              <p className="m-muted small">After approval (~48hr) you&apos;ll receive a Stripe Connect onboarding link for payouts and a Métier member login to manage your space from your owner dashboard. No subscription. No setup fee.</p>
            </form>
          </>
        )}
      </main>
    </div>
  );
}
